import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavitemCategoria } from './navitem.categoria';
import { NavitemFornecedor } from './navitem.fornecedor';
import { MaterialModule } from '../../../comum/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DialogOk } from './dialog-ok/dialog.ok';
import { ForenecedorComponent } from './produtos/forenecedor.component';
import {ItemFornecedorComponent} from './fornecedores/item.fornecedor';
import {TituloFornecedorComponent} from './titulo-fornecedor/titulo.fornecedor';
import {DownloadImgComponent}  from './download-Img';
import { AngularFireStorage } from 'angularfire2/storage';
import { SpinvalueComponent } from './spinvalue/spinvalue.component';

import { ProdutoDetailDialog } from './produtos/produto-detail.dialog';
import { MatContainerModule } from '../../../comum/controls/mat-container';
import { VerMaisDialog }  from './ver-mais/ver-mais.dialog';

@NgModule({
  providers:[
    AngularFireStorage,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    FormsModule, ReactiveFormsModule,
    MatContainerModule,
  ],
  exports: [
    NavitemCategoria,
    NavitemFornecedor,
    ForenecedorComponent,
    ItemFornecedorComponent,
    DialogOk,
    TituloFornecedorComponent,
    DownloadImgComponent
  ],
  declarations: [
    NavitemCategoria,
    NavitemFornecedor,
    DialogOk,
    ForenecedorComponent,
    ItemFornecedorComponent,
    TituloFornecedorComponent,
    DownloadImgComponent,
    SpinvalueComponent,
    ProdutoDetailDialog,
    VerMaisDialog
  ],
    entryComponents:[
      ProdutoDetailDialog,
      VerMaisDialog,
    ],

})
export class AppControlsModule { }
